<template>
    <div>

        <rkm-area
            type="fieldset"
            title="Filtros"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="agendamentoExame"
                            label="Exame"
                            show-default-option
                            text-field="nome"
                            v-model="model.exameId"
                            value-field="id"
                            default-option-text="Todos"
                            @change="handleExame()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeSolicitante"
                            label="Unidade solicitante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="unidadeId"
                            default-option-text="Todas"
                            @change="handleUnidadeSolicitante()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="infraestruturas"
                            textField="nome"
                            v-model="model.infraestruturaId"
                            valueField="id"
                            show-default-option
                            default-option-text="Todos"
                            @change="handleUnidadeSolicitante()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeColeta"
                            label="Local de coleta"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.coletaUnidadeId"
                            value-field="unidadeId"
                            default-option-text="Todos"
                            @change="handleUnidadeColeta()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="coletaInfraestruturas"
                            textField="nome"
                            v-model="model.coletaInfraestruturaId"
                            valueField="id"
                            default-option-text="Todos"
                            show-default-option
                            @change="handleUnidadeColeta()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">
                    <rkm-col cols="8">
                        <rkm-form-input-autocomplete
                            :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                            :repository="repositories.paciente"
                            v-model="paciente"
                            :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                            label="Paciente"
                            uppercase
                            @change="setListagem()"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            label="Prontuário"
                            v-model="model.prontuario"
                            number
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">
                    <rkm-col cols="12">
                        <rkm-area
                            no-margin-top
                            title="Procedimento"
                            class="mb-0 pt-0"
                        >
                            <rkm-form-select
                                :options="procedimentos"
                                :label="false"
                                text-field="procedimentoNome"
                                v-model="model.procedimentoId"
                                value-field="procedimentoId"
                                :multiple="true"
                                @change="handleProcedimento()"
                            />

                            <rkm-col class="mt-1 pt-0 col-12">
                                * Mantenha pressionado o botão Ctrl para selecionar vários procedimentos.
                            </rkm-col>

                        </rkm-area>
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">
                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="itemsNotSave"
            no-margin-top
            title="Resultado"
        >

            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                    :disabled="itemsNotSave.length === 0"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>
                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>
                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>
                <rkm-button
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                    :disabled="itemsNotSave.length === 0"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itemsNotSave.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
        </rkm-area>

        <rkm-table
            v-if="itemsNotSave"
            :items="itemsNotSave || items"
            :fields="fields"
            hide-filters
            :sort-by="sortBy"
            :sort-desc="sortDesc"
            @sort-changed="onSortChanged"
        >

            <template v-slot:cell(pacienteNome)="{ item }">

                {{ item.pacienteNome }}

                <template v-if="item.pacienteNomeSocial">
                    <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        <strong>({{ item.pacienteNomeSocial }})</strong>
                    </template>

                    <template v-else>
                        ({{ item.pacienteNomeSocial }})
                    </template>
                </template>
            </template>
        </rkm-table>

    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, file } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                coletaUnidade: { required: true },
                coletaInfraestrutura: { required: true },
            }
        },
        infraestruturas() {

            if (this.model.unidadeId && this.unidadeSolicitante.length > 0) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
        coletaInfraestruturas() {

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            coleta: this.getConectaSusRepository('exameLaboratorial.relatorioColetaRealizada'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),

            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
            exportacao: this.getConectaSusRepository('exportacao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                exameId: null,
                exameNome: null,
                unidadeId: null,
                procedimentoId: null,
                procedimentoNome: null,
                infraestruturaId: null,
                coletaUnidadeId: null,
                coletaInfraestruturaId: null,
                unidadeNome: null,
                infraestruturaNome: null,
                coletaUnidadeNome: null,
                coletaInfraestruturaNome: null,
                periodo: {
                    start: null,
                    end: null,
                },
                prontuario: null,
                pacienteId: null,
            },
            itemsNotSave: null,
            unidadeSolicitante: [],
            unidadeColeta: [],
            procedimentos: [],
            agendamentoExame: [],
            items: [],
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            columns: [
                { key: 'data', label: 'Data coleta', sortable: true, class: 'col-min', fixed: true },
                { key: 'pacienteNome', label: 'Paciente', sortable: true, class: 'col-min', fixed: true },
                { key: 'pacienteProntuario', label: 'Prontuário', sortable: true, class: 'col-min', fixed: true},
                { key: 'pacienteCns', label: 'CNS', sortable: true},
                { key: 'pacienteSexo', label: 'Sexo', class: 'col-min'},
                { key: 'dataNascimento', label: 'Data nascimento' },
                { key: 'enderecoPaciente', label: 'Logradouro'},
                { key: 'codigoProcedimento', label: 'Código procedimento', class: 'col-min', sortable: true, fixed: true },
                { key: 'nomeProcedimento', label: 'Procedimento', sortable: true, class: 'col-min', fixed: true },
                { key: 'exameNome', label: 'Exame', sortable: true, class: 'col-min', fixed: true },
                { key: 'unidadeSolicitante', label: 'Unidade solicitante'},
                { key: 'coletaUnidadeNome', label: 'Unidade coleta' },
            ],
            selectedCols: [],
            indeterminate: false,
            isProcedimentoDisabled: null,
            selectedAll: false,
            sortBy: 'data',
            sortDesc: false,
            paciente: null,
            localPaciente: {
                autocompleteFieldsPaciente: {
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
        }
    },
    mixins: [repository, error, object, formats, data, file, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo = this.data.form.periodo
        },
        search() {

            this.setLoading()

            this.repositories.coleta.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
        getSearchParams() {

            const params = this.clone(this.model)

             if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.exameId) {

                params.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (this.model.unidadeId) {

               this.model.unidadeNome = this.data.form.unidades.find(u => u.id == this.model.unidadeId).nomeFantasia
            }
            if (this.model.infraestruturaId && this.infraestruturas.length > 0) {

               this.model.infraestruturaNome = this.infraestruturas.find(u => u.id == this.model.infraestruturaId).nome
            }

            if (this.model.coletaUnidadeId) {

               this.model.coletaUnidadeNome = this.data.form.unidades.find(u => u.id == this.model.coletaUnidadeId).nomeFantasia
            }
            if (this.model.coletaInfraestruturaId) {

               this.model.coletaInfraestruturaNome = this.coletaInfraestruturas.find(u => u.id == this.model.coletaInfraestruturaId).nome
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exame = null
            this.model.exameId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.paciente = null
            this.model.prontuario = null
            this.itemsNotSave = null

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {

                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {

                this.model.infraestruturaId = null
            }
        },
        handleColetaInfraestrutura(infraestruturaColetaPrincipal) {

            if (infraestruturaColetaPrincipal.find(u => u.principal === true)) {

                this.model.coletaInfraestruturaId = infraestruturaColetaPrincipal.find(u => u.principal === true).id
            }
        },
        setInfraestrutura() {
            if(!this.model.unidadeId) {
                this.model.infraestruturaId = null;
                return;
            }
            this.model.infraestruturaId = this.data.initials.model.atendimentoUnidadeId ? this.data.initials.model.atendimentoUnidadeId : null
        },
        setColetaInfraestrutura() {

            this.model.coletaInfraestruturaId = null
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioColetaRealizada(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioColetaRealizada(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.getSearchParams()

            data.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
            data.sortDesc = this.sortDesc

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        loadFields() {

            this.setLoading()
            this.setListagem()

            this.repositories.coleta.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadExame(data.model.agendamentos)
                    this.loadProcedimento(data.model.procedimentos)
                    this.loadUnidadeSolicitante(data.model.unidades)
                    this.loadUnidadeColeta(data.model.coletas)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(agendamento) {

            const unidades = []

           agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.unidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.infraestruturaId).principal

                const unidadeInserida = unidades.find(u => u.unidadeId
                    === infraestrutura.unidadeId)

                if (unidadeInserida) {

                    let verifyUnidade = unidadeInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.infraestruturaId)

                    if (!verifyUnidade) {

                        unidadeInserida.infraestruturas.push({

                            id: infraestrutura.infraestruturaId,
                            nome: infraestrutura.infraestruturaNome,
                            principal: principal,
                        })
                    }

                } else {

                    unidades.push({

                        unidadeId: infraestrutura.unidadeId,
                        nomeFantasia: infraestrutura.unidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.infraestruturaId,
                                nome: infraestrutura.infraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeSolicitante = unidades
            const unidadesExistentes = this.unidadeSolicitante.map(q => q.unidadeId);

            if(this.data.initials.model.unidadeId && (unidadesExistentes.includes(this.data.initials.model.unidadeId))) {
                this.model.unidadeId = this.data.initials.model.unidadeId;
            }
        },
        loadUnidadeColeta(agendamento) {

            const coleta = []

           agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.coletaUnidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.coletaInfraestruturaId).principal

                const coletaInserida = coleta.find(u => u.unidadeId
                    === infraestrutura.coletaUnidadeId)

                if (coletaInserida) {

                    let verifyUnidade = coletaInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.coletaInfraestruturaId)

                    if (!verifyUnidade) {

                        coletaInserida.infraestruturas.push({

                            id: infraestrutura.coletaInfraestruturaId,
                            nome: infraestrutura.coletaUnidadeNome,
                            principal: principal,
                        })
                    }

                } else {

                    coleta.push({

                        unidadeId: infraestrutura.coletaUnidadeId,
                        nomeFantasia: infraestrutura.coletaUnidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.coletaInfraestruturaId,
                                nome: infraestrutura.coletaInfraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeColeta = coleta
            const coletasExistentes = this.unidadeColeta.map(q => q.unidadeId);

            if(this.data.initials.model.coletaId && (coletasExistentes.includes(this.data.initials.model.coletaId))) {
                this.model.coletaUnidadeId = this.data.initials.model.coletaId;
            }
        },
        loadExame(agendamento) {

            const exameCadastrado = []

            agendamento.map(exame => {

                const exameInserido = exameCadastrado.find(u => u.id === exame.exameGrupoId)

                if (!exameInserido) {

                    exameCadastrado.push({

                        id: exame.exameGrupoId,
                        nome: exame.exameGrupoNome,
                    })
                }
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado
        },
        loadProcedimento(agendamento) {
            const procedimentoCadastrado = new Map();

            agendamento.forEach(procedimento => {
                if (procedimento.procedimentoId != null && procedimento.procedimentoNome != null) {
                    if (!procedimentoCadastrado.has(procedimento.procedimentoId)) {
                        procedimentoCadastrado.set(procedimento.procedimentoId, {
                            procedimentoId: procedimento.procedimentoId,
                            procedimentoNome: procedimento.procedimentoNome
                        });
                    }
                }
            });

            this.procedimentos = Array.from(procedimentoCadastrado.values()).sort(
                (a, b) => a.procedimentoNome.localeCompare(b.procedimentoNome)
            );

            const exameId = this.model.exameId;
            const isNumero = !isNaN(parseInt(exameId)) && isFinite(exameId);
            const exameValido = isNumero || exameId === "todos";

            this.isProcedimentoDisabled = !(exameValido && this.procedimentos.length > 0);
        },
        setListagem() {

            this.itemsNotSave = null
        },
        handlePeriodo() {

            this.model.exameId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.procedimentoId = null
            this.model.paciente = null
            this.model.prontuario = null

            this.loadFields()
        },
        handleExame() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.procedimentoId = null
            this.model.paciente = null
            this.model.prontuario = null

            this.loadFields()
        },
        handleProcedimento(){

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.paciente = null
            this.model.prontuario = null

            this.loadFields()
        },
        handleUnidadeSolicitante() {

            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.paciente = null
            this.model.prontuario = null

            this.loadFields()
        },
        handleUnidadeColeta(){

            this.model.paciente = null
            this.model.prontuario = null

            this.loadFields()
        }
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.periodo.end'() {

           if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()

            }
        },
        'model.unidadeId'() {

            this.setInfraestrutura()

            if (this.model.unidadeId && this.unidadeSolicitante.length > 0) {
                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas
                this.handleInfraestrutura(infraestruturaPrincipal)
            }
        },
        'model.coletaUnidadeId'() {

            this.setColetaInfraestrutura()

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                this.handleColetaInfraestrutura(infraestruturaPrincipal)
            }
        },
    }
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}

.popover{
    max-width: 70%;
    width: auto;
}

</style>